import { useState } from "react";
import { DemoWrapper, DemoBanner } from "./styles";
import { Button, ButtonBlue } from "components/common/$styles";
import Image from "next/image";
import ChakraModal from "components/TheComponents/Modal";
import { css } from "styled-components";

const SlotDemo: React.FC<{ demoUrl: string; imageUrl: string }> = ({ demoUrl, imageUrl }) => {
  const [isModal, setIsModal] = useState<boolean>(false);
  return (
    <>
      <div>
        <h2>Demo</h2>
        <DemoWrapper>
          <DemoBanner>
            <Button onClick={() => setIsModal(true)}>
              <ButtonBlue>Play Demo</ButtonBlue>
            </Button>
          </DemoBanner>
          <Image src={imageUrl} alt="demo" width={1000} height={1000} />
        </DemoWrapper>
      </div>
      <ChakraModal
        content={
          <iframe
            src={demoUrl}
            style={{
              width: "100%",
              height: "100%",
              border: "1px solid #e9f4ff40",
              borderRadius: "4px",
            }}
          />
        }
        styles={css`
          height: 100%;
          @media (max-width: 1280px) {
            height: calc(100% - 66px);
            margin-top: 66px !important;
          }
        `}
        size="100vw"
        isOpen={isModal}
        onClose={() => setIsModal(false)}
      />
    </>
  );
};

export default SlotDemo;
